import { TRADE_PANORAMA_ART, TRADE_PANORAMAS } from "../config/tradeQuarter";
import type { ArtFrame } from "./tradeArtLayout";

export type TradePanoramaKind = keyof typeof TRADE_PANORAMAS;

/** A camera window may move towards a landmark, but never beyond the bitmap. */
export function tradePanoramaCrop(kind: TradePanoramaKind): ArtFrame {
  const camera = TRADE_PANORAMAS[kind], art = TRADE_PANORAMA_ART;
  const width = Math.min(1, camera.width) * art.width;
  const height = Math.min(1, camera.height) * art.height;
  return {
    x: Math.max(0, Math.min(art.width - width, camera.x * art.width - width / 2)),
    y: Math.max(0, Math.min(art.height - height, camera.y * art.height - height / 2)),
    width, height,
  };
}

/** Same xMidYMid/slice transform as the native raster fallback, at any aspect ratio. */
export function fitTradePanorama(kind: TradePanoramaKind, width: number, height: number): ArtFrame {
  const crop = tradePanoramaCrop(kind), art = TRADE_PANORAMA_ART;
  const scale = Math.max(width / crop.width, height / crop.height);
  return { x: width / 2 - (crop.x + crop.width / 2) * scale,
    y: height / 2 - (crop.y + crop.height / 2) * scale,
    width: art.width * scale, height: art.height * scale };
}
